"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const momentOverride_1 = __importDefault(require("@powerednow/shared/modules/utilities/momentOverride"));
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const subscription_1 = __importDefault(require("@powerednow/shared/constants/subscription"));
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
// eslint-disable-next-line no-redeclare
class Purchases extends complexData_1.default {
    static get allowedAssociations() {
        return {
            purchaseSetupAndroid: {
                key: 'purchaseSetup',
                instance: (0, modelLookup_1.complexFindModel)('PurchaseSetup'),
                single: true,
                condition: {
                    android_product_id: this.Entity.getFieldSymbols().product,
                },
            },
            purchaseSetupIOS: {
                key: 'purchaseSetup',
                instance: (0, modelLookup_1.complexFindModel)('PurchaseSetup'),
                single: true,
                condition: {
                    ios_product_id: this.Entity.getFieldSymbols().product,
                },
            },
        };
    }
    async getPurchaseSetup() {
        return (await this.getPurchaseSetupIOS()) || this.getPurchaseSetupAndroid();
    }
    async findPurchaseSetup() {
        const purchaseSetup = await this.getPurchaseSetup();
        if (!purchaseSetup) {
            const error = new Error(`No purchaseSetup for product: ${this.data.product}`);
            throw Object.assign(error, {
                severity: 8,
            });
        }
        return purchaseSetup;
    }
    /**
     * Returns the number of days between billing cycles
     *
     * @returns {number}
     */
    async getRenewCycle() {
        return (await this.findPurchaseSetup()).data.days_before_expires;
    }
    /**
     * tells if purchase is currently active with dunning period
     * @returns {boolean}
     */
    isActiveWithDunningPeriod() {
        const now = (0, momentOverride_1.default)(new Date()).format('YYYY-MM-DD HH:mm:ss');
        return this.data.expires_date >= Purchases.getOverTimedDate() && this.data.purchase_date <= now;
    }
    /**
     * tells if purchase is currently active
     * @returns {boolean}
     */
    isActive() {
        const now = (0, momentOverride_1.default)(new Date()).format('YYYY-MM-DD HH:mm:ss');
        return now <= this.data.expires_date;
    }
    static getOverTimedDate() {
        const now = new Date();
        return (0, momentOverride_1.default)(now).subtract(subscription_1.default.OVERTIME, 'days').format('YYYY-MM-DD HH:mm:ss');
    }
}
Purchases.Entity = entity_1.default;
Purchases.modelProperties = modelProperties_1.default;
exports.default = Purchases;
//# sourceMappingURL=../../../../src/models/purchases/index.js.map